/* eslint-disable prefer-template */
import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import Select from 'react-select';
import Loader from 'components/common/Loader';
import { LIVE_PAYMENT_TERMS_QUERY } from 'pages/Vendor/VendorGraphQL';

const styles = {
  control: (base) => ({
    ...base,
    fontSize: '14px',
  }),
  menu: (base) => ({
    ...base,
    fontSize: '13px',
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

const PaymentTermField = ({
  defaultValue,
  handleChange,
  placement = 'auto',
  ...rest
}) => {
  const [selectValue, setSelectValue] = useState(defaultValue || '');
  const menuPortalTarget =
    typeof document === 'undefined' ? null : document.body;

  const { data, loading, error } = useQuery(LIVE_PAYMENT_TERMS_QUERY, {
    fetchPolicy: 'network-only',
  });

  const onSelectChange = (e) => {
    setSelectValue(e);
    handleChange(e);
  };

  if (loading) return <Loader size="sm" />;
  if (error) return `There is an error on this page : ${error.message} `;
  return (
    <div
      className={`payment-terms-select status_${defaultValue?.id}`}
      //   className={`position-relative table-status ${isStatus ? handleSelectColor(selectValue) : ''}`}
    >
      <Select
        styles={styles}
        classNamePrefix="react-select"
        value={selectValue}
        onChange={onSelectChange}
        options={data?.livePaymentTerms || []}
        keys={{ id: 'id', label: 'term' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.term}
        placeholder="Select Payment Term"
        {...rest}
        menuPlacement={placement}
        menuPosition="fixed"
        menuPortalTarget={menuPortalTarget}
      />
    </div>
  );
};

export default PaymentTermField;
